<template>
  <div class="fill-width d-flex align-center">
    <div class="flex-grow-1">
      <v-text-field
        v-bind="$attrs"
        class="mt-0"
        placeholder="Address line 1"
        v-model="address.line_1"
      />
      <v-text-field
        v-bind="$attrs"
        class="mt-0"
        placeholder="Address line 2"
        v-model="address.line_2"
      />
      <div class="d-flex mx-n1">
        <v-text-field
          v-bind="$attrs"
          class="mt-0 mx-1"
          style="min-width: unset;"
          placeholder="City"
          v-model="address.city"
        />
        <v-text-field
          v-bind="$attrs"
          class="mt-0 mx-1 flex-shrink-0"
          style="width: 32px;"
          placeholder="State"
          v-model="address.region"
        />
        <v-text-field
          v-bind="$attrs"
          class="mt-0 mx-1 flex-shrink-0"
          style="width: 64px;"
          placeholder="Zip code"
          v-model="address.postal_code"
        />
        <div class="flex-grow-0 mx-1">
          <country-flag class="mb-n1 mx-n1" style="transform: scale(.8);" :country="address.country_code" />
        </div>
      </div>
    </div>
    <div v-if="$slots['append-outer']" class="ml-2" style="margin-top: 2px;">
      <slot name="append-outer"></slot>
    </div>
  </div>
</template>

<script>
import CountryFlag from '@/components/CountryFlag.vue';


const DEFAULT = { line_1: '', line_2: '', city: '', region: '', postal_code: '', country_code: 'US' };


export default {
  name: 'contact-field-address',

  components: {
    CountryFlag
  },

  props: [ 'value' ],

  data() {
    return {
      address: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(v) {
        const address = Object.assign({}, DEFAULT);
        try {
          Object.assign(address, JSON.parse(v));
        } catch (e) {
        }
        this.address = address;
      }
    },

    address: {
      deep: true,
      handler(v) {
        this.$emit('input', v ? JSON.stringify(v) : null);
      }
    }
  }
}
</script>
